// Jotly brand mark — a lowercase "j" with the tittle scaled up so the dot
// reads as a literal "jot". Ports the SVG from the design's
// jotly-shared.jsx (JotlyMark / JotlyGlyph).

interface JotlyMarkProps {
  size?: number;
  radius?: number;
  bg?: string;
  fg?: string;
  style?: React.CSSProperties;
}

export function JotlyMark({
  size = 36,
  radius,
  bg,
  fg = '#FFFFFF',
  style,
}: JotlyMarkProps) {
  const r = radius == null ? Math.round(size * 0.22) : radius;
  // The SVG viewBox is fixed at 0 0 64 64; the rx inside the SVG has to be
  // computed in viewBox-units, which is the user-supplied radius scaled up.
  const rxInViewBox = Math.round((r * 64) / size);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      style={{ display: 'block', borderRadius: r, ...style }}
      aria-label="Jotly"
    >
      <rect width="64" height="64" rx={rxInViewBox} fill={bg || 'var(--rc-accent)'} />
      <circle cx="37" cy="17" r="5" fill={fg} />
      <path
        d="M37 27 L37 42 C37 49 32 51 26 50.4 C21 49.8 19 47 18 44.5"
        stroke={fg}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

// Just the glyph (no tile background) — inherits currentColor so it can sit on
// any tinted backdrop.
interface JotlyGlyphProps {
  size?: number;
  color?: string;
  stroke?: number;
  style?: React.CSSProperties;
}

export function JotlyGlyph({
  size = 24,
  color = 'currentColor',
  stroke = 3,
  style,
}: JotlyGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      style={style}
      aria-hidden="true"
    >
      <circle cx="37" cy="17" r="5" fill={color} />
      <path
        d="M37 27 L37 42 C37 49 32 51 26 50.4 C21 49.8 19 47 18 44.5"
        stroke={color}
        strokeWidth={stroke * (8 / 3)}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
